import { getPrefixedThemeColor } from './get-prefixed-theme-value';
export const getIconSizePx = (size) => {
    switch (size) {
        case 'sm':
            return '16px';
        case 'md':
            return '24px';
        case 'lg':
            return '64px';
        default:
            throw Error('Unsupported icon size: ' + size);
    }
};
export const convertThemeColorKeyToValue = (color) => {
    return getPrefixedThemeColor(color);
};
export const convertIconPropsToSvgProps = ({ testId, size, color, ...rest }) => {
    const fontSize = getIconSizePx(size ?? 'md');
    const ariaLabel = rest['aria-label'] ?? 'icon';
    const isOutlineIcon = /outline([12])?$/i.test(ariaLabel);
    return {
        ...rest,
        fontSize,
        role: 'img',
        'data-testid': testId,
        fill: isOutlineIcon
            ? 'transparent'
            : convertThemeColorKeyToValue(color ?? 'neutral80'),
        stroke: isOutlineIcon
            ? convertThemeColorKeyToValue(color ?? 'neutral80')
            : 'transparent',
    };
};
